interface Branding { appName: string; appLogo: string | null; primaryColor: string; secondaryColor: string; accentColor: string }

export function LogoMark({ compact = false, darkText = false, branding }: { compact?: boolean; darkText?: boolean; branding?: Branding | null }) {
  const appName = branding?.appName || 'PickleSocial';
  // Try to split CamelCase name into two parts for styling (e.g. "PickleSocial" → "Pickle" + "Social")
  const match = appName.match(/^(.+?)([A-Z][a-z]+)$/);
  const part1 = match ? match[1] : appName;
  const part2 = match ? match[2] : '';

  return (
    <div className="flex items-center gap-3">
      {branding?.appLogo ? (
        <img src={branding.appLogo} alt={appName} className="h-11 w-11 shrink-0 rounded-2xl object-contain shadow-lg" />
      ) : (
        <span className="relative grid h-11 w-11 shrink-0 place-items-center overflow-hidden rounded-2xl accent-bg shadow-lg">
          <span className="h-6 w-6 rounded-full border-[5px] border-[var(--primary)]" />
          <span className="absolute bottom-1.5 right-2 h-1.5 w-1.5 rounded-full brand-bg" />
        </span>
      )}
      {!compact && <span className={`text-lg font-extrabold tracking-tight ${darkText ? 'brand-text' : 'text-white'}`}>{part1}<span className={darkText ? 'text-slate-400' : 'accent-text'}>{part2}</span></span>}
    </div>
  );
}
